import ErrorPageContent from 'components/common/general/ErrorPageContent';
import React from 'react';
import { createStyles } from './styles';

const Error404Page = (): JSX.Element => {
  const classes = createStyles();
  return (
    <main className={classes.page}>
      <div className={classes.pageContent}>
        <ErrorPageContent
          theme="black"
          errorCode={404}
          errorTitle="Page Not Found"
          errorDesc="The page you are looking for does not exist"
          showBackToHomeLink
          showHelpCenterLink
        />
      </div>
    </main>
  );
};

export default Error404Page;
